import { forwardRef } from 'react';
import clsx from 'clsx';

const SEARCH_LOUPE =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+Nzk5NzVDM0ItQ0REMS00QTUyLUExQUMtNjA0Q0FCRkYyQ0M5PC90aXRsZT48ZGVzYz5DcmVhdGVkIHdpdGggc2tldGNodG9vbC48L2Rlc2M+PHBhdGggZD0iTTIwLjgyNSAxOS45OGwtNC44Ni00Ljg2YzEuMzA0LTEuNDk5IDIuMDkzLTMuNDU1IDIuMDkzLTUuNTkyIDAtNC43MDUtMy44MjctOC41MjgtOC41MjgtOC41MjgtNC43MDUgMC04LjUyOCAzLjgyNy04LjUyOCA4LjUyOCAwIDQuNzAxIDMuODI3IDguNTI4IDguNTI4IDguNTI4IDIuMTM3IDAgNC4wOTMtLjc4OSA1LjU5Mi0yLjA5M2w0Ljg2IDQuODZjLjExNS4xMTUuMjcxLjE3Ny40MjEuMTc3LjE1MSAwIC4zMDYtLjA1OC40MjEtLjE3Ny4yMzEtLjIzMS4yMzEtLjYxMiAwLS44NDN6bS0xOC42My0xMC40NTJjMC00LjA0NCAzLjI5LTcuMzMgNy4zMy03LjMzIDQuMDQ0IDAgNy4zMyAzLjI5IDcuMzMgNy4zM3MtMy4yODYgNy4zMzUtNy4zMyA3LjMzNWMtNC4wNCAwLTcuMzMtMy4yOS03LjMzLTcuMzM1eiIgc3Ryb2tlLXdpZHRoPSIuMyIgc3Ryb2tlPSIjOTc4MTVFIiBmaWxsPSIjOTI5MjkyIi8+PC9zdmc+';

interface IInputProps {
  // ADDITIONAL PROPS:
  className?: string;
  variant?: 'standard' | 'outlined';
  rounded?: boolean;
  error?: boolean | string;
  // BASE INPUT PROPS:
  id?: string;
  type?: 'text' | 'search' | 'password' | 'number';
  name?: string;
  placeholder?: string;
  autocomplete?: boolean;
  required?: boolean;
  readOnly?: boolean;
  value?: string | number;
  onChange?: (value: string) => void;
  onBlur?: () => void;
}

export const Input = forwardRef<HTMLInputElement, IInputProps>((props, ref) => {
  return (
    <input
      ref={ref}
      className={clsx(
        'h-[40px] w-full appearance-none bg-transparent px-5 py-2.5 text-[#fff] outline-none placeholder:text-sm placeholder:text-[#ffffff66] placeholder:uppercase disabled:placeholder:text-[#443e35]',
        (!props.variant || props.variant === 'standard') && ['border-b border-b-[#ffffff66]', props.error && '!border-b-[#e42d34]'],
        props.variant === 'outlined' && [
          'border border-[#ffffff4d] transition-colors duration-200 focus:border-[#aaa]',
          props.error && '!border-[#e42d34]',
        ],
        props.type === 'search' && 'relative bg-[98%_50%] bg-no-repeat !pr-10',
        props.error && '!text-[#e42d34] placeholder:!text-[#e42d34]',
        props.rounded && '!rounded-sm',
        props.className,
      )}
      style={{ backgroundImage: `url(${props.type === 'search' && SEARCH_LOUPE})` }}
      type={props.type || 'text'}
      name={props.name}
      placeholder={props.placeholder}
      readOnly={props.readOnly}
      autoComplete={props.autocomplete ? 'on' : 'off'}
      value={props.value}
      onChange={(e) => props.onChange?.(e.target.value)}
      onBlur={props.onBlur}
      onKeyDown={(e) => {
        if (props.type === 'number' && ['e', 'E', '+', '-'].includes(e.key)) e.preventDefault();
      }}
    />
  );
});
